import React, { useEffect } from "react";
import { Gap, MyButton, MyInput } from "../../components/atoms";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import MyDialog from "../../components/molecules/Dialog";
import { useFormik } from "formik";
import * as yup from "yup";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getProfile,
  changePassword,
  changePhoneNumber,
} from "../../config/Redux/Global/actions";
import AlertMessage from "../../components/molecules/AlertMessage";

const validationSchemaPassword = yup.object().shape({
  katasandilama: yup.string().required("Silahkan Masukan Kata Sandi Lama"),
  katasandibaru: yup.string().required("Silahkan Masukan Kata Sandi Baru"),
  katasandibaruconfirm: yup
    .string()
    .required("Silahkan Konfirmasi Kata Sandi")
    .oneOf([yup.ref("katasandibaru"), null], "Kata Sandi tidak sama"),
});

const PageProfile = () => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const dispatch = useDispatch();
  const [openDialogProfile, setOpenDialogProfile] = React.useState(false);
  const [showPasswordOld, setShowPasswordOld] = React.useState(false);
  const [showPasswordNew, setShowPasswordNew] = React.useState(false);
  const [showPasswordNewConfirm, setShowPasswordNewConfirm] =
    React.useState(false);

  const dataProfile = useSelector((state) => state.global.dataProfile);
  // console.log(`dataProfile`, dataProfile);

  // alertmessage
  const [openDialogAlert, setOpenDialogAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [status, setStatus] = React.useState(null);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    formik.resetForm();
    setOpenDialog(false);
  };
  const handleOpenDialogProfile = () => {
    setOpenDialogProfile(true);
  };

  const handleCloseDialogProfile = () => {
    setOpenDialogProfile(false);
  };

  const handleClickShowPassword = (param) => {
    if (param === "oldPass") {
      setShowPasswordOld(!showPasswordOld);
    }
    if (param === "newPass") {
      setShowPasswordNew(!showPasswordNew);
    }
    if (param === "passNewConfirm") {
      setShowPasswordNewConfirm(!showPasswordNewConfirm);
    }
  };

  // formik change password
  const formik = useFormik({
    initialValues: {
      katasandilama: "",
      katasandibaru: "",
    },
    enableReinitialize: false,
    validationSchema: validationSchemaPassword,
    onSubmit: async (values) => {
      let payload = {
        lastPassword: values.katasandilama,
        newPassword: values.katasandibaru,
      };

      handleCloseDialog();
      // setLoading(true);
      const resp = await dispatch(changePassword(payload));
      handleCloseDialog();
      // console.log(`resp change password`, resp);
      if (resp.type === "UPDATE_PASSWORD_SUCCESS") {
        handleCloseDialogProfile();
        setOpenDialogAlert(true);
        setMessage(resp.payload.message);
      } else {
        setOpenDialogAlert(true);
        setMessage(resp.payload.message);
        setStatus("error");
      }
    },
  });

  // formik edit data profile
  const formikProfile = useFormik({
    initialValues: {
      name: dataProfile?.data?.name,
      email: dataProfile?.data?.email,
      // position: dataProfile?.data?.nama_tingkat_exco,
      phone: dataProfile?.data?.handphone,
      levelExco: dataProfile?.data?.nama_tingkat_exco,
      // district: "DI Yogya",
    },
    enableReinitialize: true,
    // validationSchema: validationSchemaPassword,
    onSubmit: async (values) => {
      let data = {
        phone: parseInt(values.phone),
      };
      // console.log(`payload phone`, data);
      const resp = await dispatch(changePhoneNumber(data));
      // console.log(`resp`, resp);
      if (resp.type === "UPDATE_PHONENUMBER_SUCCESS") {
        handleCloseDialogProfile();
        setOpenDialogAlert(true);
        setMessage(resp.payload.message);
        dispatch(getProfile());
        setStatus("");
      } else {
        setOpenDialogAlert(true);
        setMessage("Gagal Mengubah Nomor Telepon");
        setStatus("error");
      }
    },
  });

  const renderFormProfile = (
    <>
      <div align="center">
        <h2>
          <b>Ubah Data</b>
        </h2>
      </div>
      {/* <MyInput
        id="name"
        name="name"
        label="Nama Pengguna"
        fullWidth
        size="medium"
        value={formikProfile.values.name}
        onChange={formikProfile.handleChange}
        disabled
        type={"text"}
      /> */}
      <Gap height={20} />
      {/* <MyInput
        id="email"
        name="email"
        label="Email Pengguna"
        fullWidth
        size="medium"
        value={formikProfile.values.email}
        onChange={formikProfile.handleChange}
        disabled
        type={"text"}
      /> */}
      <Gap height={20} />
      {/* <MyInput
        id="position"
        name="position"
        label="Jabatan"
        fullWidth
        size="medium"
        value={formikProfile.values.position}
        onChange={formikProfile.handleChange}
        disabled
        type={"text"}
      />
      <Gap height={20} /> */}
      <MyInput
        id="phone"
        name="phone"
        label="Nomor Ponsel"
        fullWidth
        size="medium"
        value={formikProfile.values.phone}
        onChange={formikProfile.handleChange}
        type={"text"}
      />
      <Gap height={20} />
      {/* <MyInput
        id="levelExco"
        name="levelExco"
        label="Tingkat EXCO"
        fullWidth
        size="medium"
        disabled
        value={formikProfile.values.levelExco}
        onChange={formikProfile.handleChange}
        type={"text"}
      /> */}
      <Gap height={20} />
      {/* <MyInput
        id="district"
        name="district"
        label="Nama Daerah"
        fullWidth
        size="medium"
        disabled
        value={formikProfile.values.district}
        onChange={formikProfile.handleChange}
        type={"text"}
      />
      <Gap height={20} /> */}
      <div style={{ display: "flex" }}>
        <MyButton
          height="40px"
          color="#B9B9B9"
          fullWidth
          backgroundColor="#FFFFFFFF"
          borderColor="#B9B9B9"
          backgroundColorHover="#FFFFFFFF"
          variant="outlined"
          children="Batal"
          onClick={handleCloseDialogProfile}
        />
        <Gap width={30} />
        <MyButton
          height="40px"
          color="#8B8B8B"
          colorHover="white"
          fullWidth
          backgroundColor="#E8E8E8"
          borderColor="#E8E8E8"
          backgroundColorHover="#F06524"
          variant="outlined"
          children="Simpan"
          type="submit"
          onClick={formikProfile.handleSubmit}
        />
      </div>
    </>
  );

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);
  const renderFormPassword = (
    <>
      <div align="center">
        <h2>
          <b>Ubah Kata Sandi</b>
        </h2>
        <Gap height={20} />
        <MyInput
          id="katasandilama"
          name="katasandilama"
          label="Kata Sandi Lama*"
          fullWidth
          size="medium"
          value={formik.values.katasandilama}
          onChange={formik.handleChange}
          error={
            formik.touched.katasandilama && Boolean(formik.errors.katasandilama)
          }
          helperText={
            formik.touched.katasandilama && formik.errors.katasandilama
          }
          type={showPasswordOld ? "text" : "password"}
          InputProps={{
            // <-- This is where the toggle button is added.
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => handleClickShowPassword("oldPass")}
                  // onMouseDown={handleMouseDownPassword}
                >
                  {showPasswordOld ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <hr />
        <MyInput
          id="katasandibaru"
          name="katasandibaru"
          label="Kata Sandi Baru*"
          fullWidth
          size="medium"
          value={formik.values.katasandibaru}
          onChange={formik.handleChange}
          error={
            formik.touched.katasandibaru && Boolean(formik.errors.katasandibaru)
          }
          helperText={
            formik.touched.katasandibaru && formik.errors.katasandibaru
          }
          type={showPasswordNew ? "text" : "password"}
          InputProps={{
            // <-- This is where the toggle button is added.
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => handleClickShowPassword("newPass")}
                  // onMouseDown={handleMouseDownPassword}
                >
                  {showPasswordNew ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Gap height={20} />
        <MyInput
          id="katasandibaruconfirm"
          name="katasandibaruconfirm"
          label="Kata Sandi Baru Konfirmasi*"
          fullWidth
          size="medium"
          value={formik.values.katasandibaruconfirm}
          onChange={formik.handleChange}
          error={
            formik.touched.katasandibaruconfirm &&
            Boolean(formik.errors.katasandibaruconfirm)
          }
          helperText={
            formik.touched.katasandibaruconfirm &&
            formik.errors.katasandibaruconfirm
          }
          type={showPasswordNewConfirm ? "text" : "password"}
          InputProps={{
            // <-- This is where the toggle button is added.
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => handleClickShowPassword("passNewConfirm")}
                  // onMouseDown={handleMouseDownPassword}
                >
                  {showPasswordNewConfirm ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Gap height={20} />
        <div style={{ display: "flex" }}>
          <MyButton
            height="40px"
            color="#B9B9B9"
            fullWidth
            backgroundColor="#FFFFFFFF"
            borderColor="#B9B9B9"
            backgroundColorHover="#FFFFFFFF"
            variant="outlined"
            children="Batal"
            onClick={handleCloseDialog}
          />
          <Gap width={30} />
          <MyButton
            height="40px"
            color="#8B8B8B"
            colorHover="white"
            fullWidth
            backgroundColor="#E8E8E8"
            borderColor="#E8E8E8"
            backgroundColorHover="#F06524"
            variant="outlined"
            children="Simpan"
            type="submit"
            onClick={formik.handleSubmit}
          />
        </div>
      </div>
    </>
  );
  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <MyDialog
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        renderValue={renderFormPassword}
        fullWidth={true}
        maxWidth={"sm"}
      />
      <MyDialog
        openDialog={openDialogProfile}
        handleCloseDialog={handleCloseDialogProfile}
        renderValue={renderFormProfile}
        fullWidth={true}
        maxWidth={"sm"}
      />
      {/* alertMessage */}
      <AlertMessage
        openDialog={openDialogAlert}
        message={message}
        status={status}
        handleCloseDialog={() => setOpenDialogAlert(false)}
      />
      <Gap height={20} />

      {/* Page Title */}
      <p style={{ fontSize: 24, fontWeight: 700, marginBottom: 20 }}>Profil</p>

      {/* Profile Info Card */}
      <Paper
        elevation={0}
        style={{
          padding: "32px 40px",
          borderRadius: 12,
          marginBottom: 20,
        }}
      >
        {/* Name and Role */}
        <div style={{ marginBottom: 24 }}>
          <h2
            style={{
              fontSize: 24,
              fontWeight: 700,
              margin: 0,
              marginBottom: 4,
            }}
          >
            {dataProfile?.data?.name || "-"}
          </h2>
          <p style={{ fontSize: 14, color: "#333", margin: 0 }}>
            {dataProfile?.data?.nama_tingkat_exco || "-"}
          </p>
        </div>

        {/* Location Info - 3 columns */}
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <label style={{ fontSize: 12, fontWeight: 400, color: "#757575" }}>
              Provinsi
            </label>
            <p
              style={{
                fontSize: 14,
                fontWeight: 600,
                marginTop: 4,
                color: "#333",
              }}
            >
              {dataProfile?.data?.nama_provinsi || "-"}
            </p>
          </Grid>
          <Grid item xs={12} sm={4}>
            <label style={{ fontSize: 12, fontWeight: 400, color: "#757575" }}>
              Kabupaten
            </label>
            <p
              style={{
                fontSize: 14,
                fontWeight: 600,
                marginTop: 4,
                color: "#333",
              }}
            >
              {dataProfile?.data?.nama_kabkot || "-"}
            </p>
          </Grid>
          <Grid item xs={12} sm={4}>
            <label style={{ fontSize: 12, fontWeight: 400, color: "#757575" }}>
              Kecamatan
            </label>
            <p
              style={{
                fontSize: 14,
                fontWeight: 600,
                marginTop: 4,
                color: "#333",
              }}
            >
              {dataProfile?.data?.nama_kecamatan || "-"}
            </p>
          </Grid>
        </Grid>

        {/* Divider */}
        <div style={{ borderTop: "1px solid #e5e5e5", margin: "24px 0" }} />

        {/* Akun Section */}
        <h3
          style={{
            fontSize: 16,
            fontWeight: 600,
            color: "#ff6801",
            marginBottom: 20,
          }}
        >
          Akun
        </h3>

        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <label style={{ fontSize: 12, fontWeight: 400, color: "#757575" }}>
              Email
            </label>
            <p
              style={{
                fontSize: 14,
                fontWeight: 600,
                marginTop: 4,
                color: "#333",
              }}
            >
              {dataProfile?.data?.email || "-"}
            </p>
          </Grid>
          <Grid item xs={12} sm={4}>
            <label style={{ fontSize: 12, fontWeight: 400, color: "#757575" }}>
              Password
            </label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginTop: 4,
              }}
            >
              <span style={{ fontSize: 14, fontWeight: 600, color: "#333" }}>
                ••••••••
              </span>
              <span
                onClick={handleOpenDialog}
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#ff6801",
                  cursor: "pointer",
                }}
              >
                Ubah Password
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <label style={{ fontSize: 12, fontWeight: 400, color: "#757575" }}>
              Nomor Ponsel
            </label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginTop: 4,
              }}
            >
              <span style={{ fontSize: 14, fontWeight: 600, color: "#333" }}>
                {dataProfile?.data?.handphone || "-"}
              </span>
              <span
                onClick={handleOpenDialogProfile}
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#ff6801",
                  cursor: "pointer",
                }}
              >
                Ubah
              </span>
            </div>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default PageProfile;
